/**
 * ERPs Delete Policy
 * 
 * Handles ERP deletion:
 * - Reacts when delete is confirmed
 * - Calls backend delete command
 * - Closes modal on success
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { ERPsState } from '../state';
import { ERPsCommand } from '../commands';

/**
 * Creates a policy that handles ERP deletion
 */
export const createERPsDeletePolicy = (
  backend: ClientLibraryType
): Policy<ERPsState, ERPsCommand> => ({
  name: 'erps-delete',

  shouldReact: ( prev, next ) => {
    // React when delete operation starts
    return (
      !prev.loading.deleting &&
      next.loading.deleting &&
      next.deleteModal.erpId !== null
    );
  },

  onStateChange: async ({ next, ctx }) => {
    const { erpId } = next.deleteModal;
    
    if ( !erpId ) {
      console.error( '[erps] Delete called without ERP ID' );
      ctx.dispatch(
        { type: 'integrations/erps/loading/setDeleting', payload: { isLoading: false }},
        { source: 'api' }
      );
      return;
    }

    try {
      // TODO: Implement backend delete command when available
      // await backend.commands.DeleteSalesChannelIntegration({
      //   id: erpId
      // });
      console.warn( '[erps] Backend delete command not implemented yet' );

      // Optimistic remove (subscription will also handle this)
      ctx.dispatch(
        { type: 'integrations/erps/data/remove', payload: { erpId }},
        { source: 'api' }
      );

      // Close modal and reset loading
      ctx.dispatch(
        { type: 'integrations/erps/delete/close', payload: {}},
        { source: 'api' }
      );
      ctx.dispatch(
        { type: 'integrations/erps/loading/setDeleting', payload: { isLoading: false }},
        { source: 'api' }
      );
    } catch ( error ) {
      ctx.dispatch(
        { type: 'integrations/erps/loading/setDeleting', payload: { isLoading: false }},
        { source: 'api' }
      );
    }
  }
});
